import { Form, Space } from 'antd'
import { FormItemProps } from 'antd/es/form'
import { ReactNode } from 'react'

interface BaseProps {
  children: ReactNode
  formItemProps: FormItemProps
  noWrapAddon?: boolean
}

type Props =
  | (BaseProps & { addonAfter: ReactNode; addonBefore?: ReactNode | undefined })
  | (BaseProps & { addonBefore: ReactNode; addonAfter?: ReactNode | undefined })

export const SBFormItemAddon = ({
  children,
  formItemProps,
  addonAfter,
  addonBefore,
  noWrapAddon,
}: Props) => {
  return (
    <Form.Item
      label={formItemProps?.label}
      required={formItemProps?.required}
      noStyle={formItemProps?.noStyle}
      hidden={formItemProps?.hidden}
    >
      <Space.Compact block>
        {addonBefore &&
          (noWrapAddon ? (
            addonBefore
          ) : (
            <Space.Addon>{addonBefore}</Space.Addon>
          ))}

        <Form.Item {...formItemProps} noStyle>
          {children}
        </Form.Item>

        {addonAfter &&
          (noWrapAddon ? addonAfter : <Space.Addon>{addonAfter}</Space.Addon>)}
      </Space.Compact>
    </Form.Item>
  )
}
